import React, { useEffect } from 'react';

const useCacheDateFilterValue = (range) => {
  const cahcedRange =
    sessionStorage.getItem('dtr') &&
    JSON.parse(sessionStorage.getItem('dtr'));

  const isDuplicate =
    cahcedRange?.fmd === range?.FromDate &&
    cahcedRange?.td === range?.ToDate;

  useEffect(() => {
    if (range)
      if (range.FromDate && range.ToDate) {
        if (!cahcedRange || !isDuplicate) {
          sessionStorage.setItem(
            'dtr',
            JSON.stringify({
              fmd: range.FromDate,
              td: range.ToDate,
            })
          );
        }
      }
  }, [range, cahcedRange]);
};

export default useCacheDateFilterValue;
